import { render } from "./MlopsListView.vue?vue&type=template&id=518b00c4&scoped=true"
import script from "./MlopsListView.vue?vue&type=script&lang=js"
export * from "./MlopsListView.vue?vue&type=script&lang=js"

import "./MlopsListView.vue?vue&type=style&index=0&id=518b00c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518b00c4"]])

export default __exports__